import React from "react";
import { ButtonGroup, Button } from "reactstrap";

const PERIODS = [
  { value: 7, label: "7d" },
  { value: 14, label: "14d" },
  { value: 30, label: "30d" },
  { value: 60, label: "60d" },
  { value: 90, label: "90d" },
  { value: 180, label: "6m" },
  { value: 365, label: "1a" },
];

const PeriodSelector = ({ value, onChange, maxDays, className = "" }) => (
  <ButtonGroup size="sm" className={className}>
    {PERIODS.map((p) => {
      const disabled = maxDays != null && p.value > maxDays;
      return (
        <Button
          key={p.value}
          color={value === p.value ? "primary" : "light"}
          onClick={() => !disabled && onChange(p.value)}
          disabled={disabled}
          style={{ minWidth: 38 }}
          title={disabled ? `Solo hay ${maxDays} ${maxDays === 1 ? "día" : "días"} de datos` : ""}
        >
          {p.label}
        </Button>
      );
    })}
  </ButtonGroup>
);

export default PeriodSelector;
